import React, { useEffect, useState } from 'react';
import { portfolioData } from '../mock';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import About from '../components/About';
import Contact from '../components/Contact';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Chatbot from '../components/Chatbot';

const Home = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Header scrolled={scrolled} />
      <Hero data={portfolioData.hero} />
      <Services data={portfolioData.services} />
      <Portfolio data={portfolioData.portfolio} />
      <Process data={portfolioData.process} />
      <Testimonials data={portfolioData.testimonials} />
      <About data={portfolioData.about} />
      <Contact data={portfolioData.contact} />
      <Footer />
      <Chatbot />
    </div>
  );
};

export default Home;